// Recovered compiled webpack factory 30534. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { B3: () => h, Ex: () => m, eN: () => f, kF: () => d, tC: () => u, uc: () => p });
  var r = a(95704);
  let n = new Set([
      "authorization",
      "cookie",
      "set-cookie",
      "stripe-signature",
      "x-api-key",
      "x-auth-token",
    ]),
    o =
      /^(token|api[_-]?key|license[_-]?key|secret|access[_-]?token|refresh[_-]?token|session[_-]?id|checkout[_-]?session[_-]?id|otp|code|password|csrf|x[_-]?api[_-]?key)$/i,
    s = /^(email|e[-_]?mail)$/i,
    i = /(sk_(live|test)_[A-Za-z0-9]+|whsec_[A-Za-z0-9]+|Bearer\s+[A-Za-z0-9._-]+)/g,
    c = ["url", "to", "from"];
  function l(e) {
    return o.test(e) || s.test(e);
  }
  function d() {
    return r.env.VERCEL_GIT_COMMIT_SHA ?? "9d46c9a45a26a0fc2299a28bea5b70ae4e2f7a1e";
  }
  function p() {
    return r.env.VERCEL_ENV ?? "production" ?? "development";
  }
  function f() {
    return "1" === r.env.VERCEL || !0;
  }
  function h() {
    return f();
  }
  let u = [
    "AbortError",
    "AbortController",
    "ResizeObserver loop",
    "NetworkError when attempting to fetch resource",
    "Load failed",
  ];
  function m(e, t) {
    if (e.request) {
      if (e.request.headers)
        for (let t of Object.keys(e.request.headers))
          n.has(t.toLowerCase()) && (e.request.headers[t] = "[Filtered]");
      ("string" == typeof e.request.query_string &&
        (e.request.query_string = g(e.request.query_string)),
        "string" == typeof e.request.url && (e.request.url = b(e.request.url)),
        e.request.data && (e.request.data = y(e.request.data)));
    }
    if ((e.extra && (e.extra = y(e.extra)), e.breadcrumbs)) {
      for (let t of e.breadcrumbs)
        if (("string" == typeof t.message && (t.message = _(t.message)), t.data)) {
          for (let e of c) "string" == typeof t.data[e] && (t.data[e] = b(t.data[e]));
          t.data = y(t.data);
        }
    }
    return e;
  }
  function b(e) {
    let t = e.indexOf("#"),
      a = -1 === t ? "" : e.slice(t),
      r = -1 === t ? e : e.slice(0, t),
      n = r.indexOf("?");
    return -1 === n ? e : `${r.slice(0, n)}?${g(r.slice(n + 1))}${a}`;
  }
  function g(e) {
    let t = new URLSearchParams(e);
    for (let e of Array.from(t.keys()))
      if (l(e)) {
        let a = t.getAll(e);
        t.delete(e);
        for (let r = 0; r < a.length; r++) t.append(e, "[Filtered]");
      } else {
        let a = t.getAll(e);
        for (let r of (t.delete(e), a)) t.append(e, _(r));
      }
    return t.toString();
  }
  function y(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
    if (t > 5) return "[MaxDepth]";
    if (null == e) return e;
    if ("string" == typeof e) return _(e);
    if ("object" != typeof e) return e;
    if (Array.isArray(e)) return e.map((e) => y(e, t + 1));
    let a = {};
    for (let [r, o] of Object.entries(e))
      l(r) || n.has(r.toLowerCase()) ? (a[r] = "[Filtered]") : (a[r] = y(o, t + 1));
    return a;
  }
  function _(e) {
    return e.replace(i, "[Filtered]");
  }
}
